import { render } from "./BtnFlex.vue?vue&type=template&id=17ac4991&scoped=true"
import script from "./BtnFlex.vue?vue&type=script&lang=js"
export * from "./BtnFlex.vue?vue&type=script&lang=js"

import "./BtnFlex.vue?vue&type=style&index=0&id=17ac4991&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ac4991"]])

export default __exports__